/* lua.js generated code 0.3.0 */

var PushBounceAnim = require("clover/panel/component/common/uiButtonAnims/PushBounceAnim")
var LosePanelStrategyPrompt = xClass("LosePanelStrategyPrompt", BasePanel, function () {
    // WARN: maybe multi result
    return cc.CSLoader.createNode("cocos/panel_adprompt_panel_adprompt.csb")
})
LosePanelStrategyPrompt.prototype.ctor = function (strategyId, okCb) {
    var self = this;
    self.okCb = okCb;
    self.strategyId = strategyId;
    self.bind(self);
    BasePanel.prototype.init.call(self);
    self.init();
    self.popup();
}
LosePanelStrategyPrompt.prototype.init = function () {
    var self = this;
    
    var close = UIGroupButton.create(self.getChildByName("btn_close"));
    PushBounceAnim.create(close);
    close.on(UIButtonEvent.Click, function () {
        DCAssist.userTrack("levelTip", "ad_canel");
        self.onClose();
    })
    var txt = self.getChildByName("txt");
    txt.setString(getText("leveltip.gettip.ad"));
    txt.height += 10;
    var button = UIGroupButton.create(self.getChildByName("btn_green_continue"));
    PushBounceAnim.create(button);
    button.getChildByName("label").setPositionX(-15);
    button.on(UIButtonEvent.Click, function () {
        // DYAdUtil.showAdSecondConfirmPanel(()=>{
            cc.UserDefault.getInstance().setBoolForKey(LOCAL_STRATEGY_CHECK_TIP, self.checkMark);
            self.okCb();
            self.onClose();
        // });
    })
    let icon_ad = DYAdUtil.addAdIcon(button);
    icon_ad.setScale(0.7)
    icon_ad.x -= 60
    icon_ad.y += 10

    var checkNode = self.getChildByName("checkmark_choose");
    txt = checkNode.getChildByName("txt");
    txt.setString(getText("common.nomoretip.text"));
    self.checkMark = cc.UserDefault.getInstance().getBoolForKey(LOCAL_STRATEGY_CHECK_TIP, false);
    checkNode.getChildByName("checkmark_on").setVisible(false);
    checkNode.getChildByName("checkmark_off").setVisible(true);
    var button = UIGroupButton.create(checkNode.getChildByName("checkmark_bg"));
    // PushBounceAnim.create(button);
    button.on(UIButtonEvent.Click, function () {
        self.switchCheckMark();
    })

    self.setScale(self.getReferenceScale());
}

LosePanelStrategyPrompt.prototype.popup = function () {
    var self = this
    var targetScale = self.getScale()
    self.setScale(0)
    var time = 7 / 30
    PopoutManager.getInstance().addWithBgFadeIn(self, true, false)
    var dH = display.height-GamePlayConfig_Design_Height;
    var targetPos = cc.pAdd(cc.p(self.getPosition()), cc.p(55, 850 + dH/2));
    var pos_O = cc.p(display.width / 2, display.height / 2)
    var startPoint = cc.pMul(cc.pSub(targetPos, pos_O), 0.23)
    self.setScale(0.23)
    self.setPosition(cc.p(pos_O.x + startPoint.x, pos_O.y + startPoint.y))
    self.runAction(cc.Sequence.create(cc.EaseSineOut.create(cc.Spawn.create(cc.ScaleTo.create(time, targetScale), cc.MoveTo.create(time, targetPos)))))
    return self
}
LosePanelStrategyPrompt.prototype.switchCheckMark = function () {
    var self = this;
    self.checkMark = !self.checkMark;
    var checkNode = self.getChildByName("checkmark_choose");
    checkNode.getChildByName("checkmark_on").setVisible(self.checkMark);
    checkNode.getChildByName("checkmark_off").setVisible(!self.checkMark);
}

LosePanelStrategyPrompt.prototype.onCleanup = function () {
    ResManager.release(["packed/StrategyAdPrompt.pack"]);
}

module.exports = LosePanelStrategyPrompt;
